import React, { Component } from 'react'
import {MasterLayout} from 'layout';
import {DanhMucTongHopThanhTra} from 'modules/thanh-tra-trung'


export default class DanhMucTongHopThanhTraPage extends Component {
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhMucTongHopThanhTra type={this.props.route.type}/>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra-trung/DanhMucTongHopThanhTraPage.jsx